// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
// 全局组建
import '@/plugin'
// 路由
import router from './router'
// eslint-disable-next-line
import $ from 'jquery'
// mete标签
import MetaInfo from 'vue-meta-info'
// 雪碧图
import '@/assets/sprite/sprite.css'
// iconfont图标
import '@/assets/iconfont/iconfont.css'
Vue.config.productionTip = false
// 设置meta标签
Vue.use(MetaInfo)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js